<div
  class="body ui container"
  fxLayout="column"
  [ngClass]="{ loading: pending }"
>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <span class="ui grey">Home / eWallet</span>
        <h2 class="ui primary header">eWallet</h2>
      </div>
    </div>
  </div>
  <div class="ui divider"></div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div class="contents">
      <img src="assets/images/wallet.png" alt="" />
      <h3 class="mt-26 mb-0 text-top">
        This section does not contain any data.
      </h3>
      <h3 class="mb-24 mt-0 text-top">
        You can manage your eWallet accounts and transactions here.
      </h3>

      <p class="my-0 text-bottom">
        The eWallet enables you to transfer funds to NCC in advance,
      </p>
      <p class="my-0 text-bottom">
        ensuring that there are no delays when you are ready to pay
      </p>
      <p class="my-0 text-bottom">for services.</p>

      <button
        class="ui small button primary my-24"
        [disabled]="!user['totpEnabled']"
        (click)="goToActivateWallet()"
      >
        Activate your eWallet
      </button>
      <p class="my-0 text-bottom">
        Please note that only users with enabled 2-factor authentication
      </p>
      <p class="my-0 text-bottom">
        (2FA) can activate their e-wallet account or conduct
      </p>
      <p class="my-0 text-bottom">any transactions using their e-wallet.</p>
      <br />
      <p class="my-0 text-bottom">
        To enable your 2FA, on the top right, click on your company name, select
        "Settings"
      </p>
      <p class="my-0 text-bottom">
        then click "Account Security" toggle the 2FA button and follow the
        onscreen instructions
      </p>
    </div>
  </div>
</div>
